<template>
  <div class="steps-container">
    <div v-if="conditions" class="steps">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step"
      >
        <div class="circle-price">
          <span>
            {{ step.value }}%
          </span>
        </div>
        <div class="rules">
          <span v-if="step.quantityOfPeople">
            {{ $tc('groupDeal.requirements.people', step.quantityOfPeople) }}
          </span>
          <span v-if="step.quantityOfPeople && step.quantity">
            {{ $t('fields.and') }}
          </span>
          <span v-if="step.quantity">
            {{ $tc('groupDeal.requirements.products', step.quantity) }}
          </span>
        </div>
      </div>
    </div>
    <div v-if="!conditions" class="steps">
      <div
        v-for="(step, index) in steps"
        :key="index"
        :class="index < nextStep ? 'step active' : 'step'"
      >
        <div class="circle-price">
          {{ step.value }}%
        </div>
        <div class="rules">
          <span v-if="step.quantityOfPeople">
            {{ $tc('groupDeal.requirements.people', step.quantityOfPeople) }}
          </span>
          <span v-if="step.quantityOfPeople && step.quantity">
            {{ $t('fields.and') }}
          </span>
          <span v-if="step.quantity">
            {{ $tc('groupDeal.requirements.products', step.quantity) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true
    },
    conditions: {
      type: Boolean
    },
    nextStep: {
      type: Number
    },
    status: {
      type: Number
    }
  }
}
</script>
